export const types = {
    ADMIN_SEARCH_USERS: 'adminUserSearch/ADMIN_SEARCH_USERS',
    ADMIN_SEARCH_USERS_SUCCESS: 'adminUserSearch/ADMIN_SEARCH_USERS_SUCCESS',
    ADMIN_SEARCH_USERS_FAIL: 'adminUserSearch/ADMIN_SEARCH_USERS_FAIL',

    FETCH_ADVANCED_SEARCH_FILTER_OPTIONS: 'adminUserSearch/FETCH_ADVANCED_SEARCH_FILTER_OPTIONS',
    FETCH_ADVANCED_SEARCH_FILTER_OPTIONS_SUCCESS: 'adminUserSearch/FETCH_ADVANCED_SEARCH_FILTER_OPTIONS_SUCCESS',
    FETCH_ADVANCED_SEARCH_FILTER_OPTIONS_FAIL: 'adminUserSearch/FETCH_ADVANCED_SEARCH_FILTER_OPTIONS_FAIL',

    POST_ADMIN_ADVANCED_SEARCH: 'adminUserSearch/POST_ADMIN_ADVANCED_SEARCH',
    POST_ADMIN_ADVANCED_SEARCH_SUCCESS: 'adminUserSearch/POST_ADMIN_ADVANCED_SEARCH_SUCCESS',
    POST_ADMIN_ADVANCED_SEARCH_FAIL: 'adminUserSearch/POST_ADMIN_ADVANCED_SEARCH_FAIL',
};
